<template>
  <div class="text-input">
    <label :for="`input_${identifier}`">
      {{displayName}}
    </label>
    <div :id="`input_${identifier}`" class="v-input" />
  </div>
</template>

<script>
export default {
  props: {
    displayName: {
      type: String,
      required: true,
    },
    identifier: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input {
  height: 4.25em;
}
</style>
